// extracted by mini-css-extract-plugin
module.exports = {"container":"Nv","productName":"Ov","modal":"Pv","dimensions":"Qv","recipientEmail":"Rv","lowStock":"Sv","recommendedFit":"Tv","notRecommendedFit":"Uv"};